

















































































import { Component, Prop } from "vue-property-decorator";
import { requiredRule } from "@/lib/rules/requiredRule.ts";
import { emailRule } from "@/lib/rules/contactRule.ts";
import { UserModule } from "@/store/modules/user.store";
import { ChangePasswordIfRequiredDto } from "@/services/mrfiktiv/v1/mrfiktiv.api";
import LoginMixin from "@/mixins/LoginMixin.vue";
import { LoginCardEnum } from "@/store/enum/loginCardEnum";
import LoginPasswordRequirementList from "@/components/login/LoginPasswordRequirementList.vue";

@Component({
  components: { LoginPasswordRequirementList }
})
export default class NewPassword extends LoginMixin {
  @Prop()
  changePassword!: Function;

  @Prop()
  changeMail!: Function;

  password = this.initialPasswordValue || "";

  isPasswordVisible1 = false;
  isPasswordVisible2 = false;
  isPasswordVisible3 = false;

  isFormValid = false;

  get emailRules() {
    return [requiredRule(), emailRule()];
  }

  get required() {
    return [requiredRule()];
  }

  get getIsFormValid() {
    return this.isFormValid && this.password1 === this.password2;
  }

  constructor() {
    super();
  }

  backToLogin() {
    this.changePassword(this.password);
    this.changeMail(this.mail);
    this.changeCard(LoginCardEnum.LOGIN);
  }

  async submit() {
    this.changePassword(this.isPasswordVisible3);
    this.changeMail(this.mail);

    const changePasswordIfRequired: ChangePasswordIfRequiredDto = {
      previousPassword: this.password,
      proposedPassword: this.password2,
      username: this.mail
    };
    try {
      await UserModule.changePasswordIfRequired(changePasswordIfRequired);
      this.checkIfUserIsLoggedInAndRedirect();
    } catch (error) {
      this.$log.info("set password failed");
      this.setFailMessage("Fehler: Prüfen Sie Ihre Eingaben oder versuchen Sie es später noch einmal.");
    }
  }
}
